module.exports = __webpack_public_path__ + "img/truckRearRight.ed07ad79.svg";